unit View.Modalidades.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils, UPersonalizacao_Tabela,
  UPersonalizacao_Tabela.Interfaces, UConstantes, System.StrUtils;

type
  TFViewModalidadesList = class(TForm)
    ModalidadesDataset: TXDataWebDataSet;
    ModalidadesDatasetnome: TStringField;
    ModalidadesDatasetpermite_prazo: TBooleanField;
    ModalidadesDatasetmodalidade_avista: TBooleanField;
    ModalidadesDatasetmodalidade_cheque_vinculado: TBooleanField;
    ModalidadesDatasetmodalidade_prazo_fixo: TBooleanField;
    ModalidadesDatasetmodalidade_pagamento_digital: TBooleanField;
    ModalidadesDatasetmodalidade_pix: TBooleanField;
    ModalidadesDatasetmodalidade_cartao: TBooleanField;
    ModalidadesDatasettipo_cartao: TIntegerField;
    ModalidadesDatasetprazo_dias: TIntegerField;
    ModalidadesDatasetdia_fixo: TIntegerField;
    ModalidadesDatasetcodigo_interno: TIntegerField;
    ModalidadesDatasetexcluido: TBooleanField;
    ModalidadesDatasetinclusao: TDateTimeField;
    ModalidadesDatasetalteracao: TDateTimeField;
    ModalidadesDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    ModalidadesDatasetapi_pixid: TIntegerField;
    ModalidadesDatasetpix_integrado: TBooleanField;
    ModalidadesDatasetstatus: TIntegerField;
    ModalidadesDatasetmodalidade_web: TBooleanField;
    procedure WebFormCreate(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure tmrConsultaTimer(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure WebDBTableControl1GetCellClass(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; var AClassName: string);
    procedure WebDBTableControl1GetCellData(Sender: TObject; ACol,
      ARow: Integer; AField: TField; var AValue: string);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
    FPersonalizacaoTabela: IPersonalizacao_Tabela;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewModalidadesList: TFViewModalidadesList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModalidadesList }

procedure TFViewModalidadesList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewModalidadesList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModalidadesList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewModalidadesList, AElementID, Result, @AfterCreate);
end;

procedure TFViewModalidadesList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
  begin
    FGridPlugin.SetFilterText(edSearch.Text, True);
  end;
end;

procedure TFViewModalidadesList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewModalidadesList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewModalidadesList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Ação' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      ModalidadesDataset.Connection.Model.DefaultSchema.FindEntityType(ModalidadesDataset.EntitySetName),
      ModalidadesDataset.CurrentData
    );

    Button := TButton.Create(nil);
    Button.Caption := '<i class="fas fa-eye"></i>';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-link btn-primary btn-lg';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
    Button.ElementHandle.style.setProperty('padding', '10px');
    Button.ElementHandle.setAttribute('data-test', 'btn_visualizar_modalidade');
  end;
end;

procedure TFViewModalidadesList.WebDBTableControl1GetCellClass(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string; var AClassName: string);
begin
  if ARow = 0 then
    AClassName := 'text-center'
  else
  begin
    case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['nome']) of
      0 : AClassName := 'text-start';
      else AClassName := 'text-center';
    end;
  end;
end;

procedure TFViewModalidadesList.WebDBTableControl1GetCellData(Sender: TObject;
  ACol, ARow: Integer; AField: TField; var AValue: string);
begin
  if ARow = 0 then
    Exit;

  case IndexStr(WebDBTableControl1.Columns[ACol].DataField, ['permite_prazo', 'modalidade_avista',
    'modalidade_cheque_vinculado','modalidade_prazo_fixo', 'modalidade_pagamento_digital',
    'modalidade_pix', 'modalidade_cartao', 'excluido', 'tipo_cartao', 'pix_integrado', 'status',
    'modalidade_web']) of
    0, 1, 2, 3, 4, 5, 6, 7, 9, 11:
    begin
      if AValue = 'True' then
        AValue := '<i class="fas fa-check text-success"><i>'
      else if AValue = 'False' then
        AValue := '<i class="fas fa-times text-danger"><i>';
    end;
    8:
    begin
      if AValue = '1' then
        AValue := 'CRÉDITO'
      else if AValue = '2' then
        AValue := 'DÉBITO';
    end;
    10:
    begin
      if not AValue.IsEmpty then
      begin
        if AValue = '1' then
          AValue := '<div class="rounded-pill text-center" style="background-color: #198754;color:white; padding-right: 5px;padding-left: 5px;">Ativo</div>'
        else
          AValue := '<div class="rounded-pill text-center" style="background-color: #FF6347;color:white; padding-right: 5px;padding-left: 5px;">Inativo</div>';
      end;
    end;
  end;
end;

procedure TFViewModalidadesList.WebFormCreate(Sender: TObject);
begin
  FPersonalizacaoTabela := TPersonalizacao_Tabela.Create(Self.Name, WebDBTableControl1,
    cbPageSize);

  TUtils.SetValorDicionarioClasses('modalidades', 'active');
  TUtils.SetValorDicionarioClasses('cadastros_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_cadastros', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(WebDBTableControl1, ModalidadesDataset,lcPaginator,
    lbPaginationInfo);

  FGridPlugin.FDatasetPlugin.FOrderByPadrao := 'nome';
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewModalidadesList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.modalidades.list.pagination.info');
  WebDBTableControl1 := TDBTableControl.Create('view.modalidades.list.table');
  cbPageSize := TComboBox.Create('view.modalidades.list.cbPageSize');
  edSearch := TEdit.Create('view.modalidades.list.search');
  lcPaginator := TListControl.Create('view.modalidades.list.pagination');
  ModalidadesDataset := TXDataWebDataSet.Create(Self);
  ModalidadesDatasetnome := TStringField.Create(Self);
  ModalidadesDatasetpermite_prazo := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_avista := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_cheque_vinculado := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_prazo_fixo := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_pagamento_digital := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_pix := TBooleanField.Create(Self);
  ModalidadesDatasetmodalidade_cartao := TBooleanField.Create(Self);
  ModalidadesDatasettipo_cartao := TIntegerField.Create(Self);
  ModalidadesDatasetprazo_dias := TIntegerField.Create(Self);
  ModalidadesDatasetdia_fixo := TIntegerField.Create(Self);
  ModalidadesDatasetcodigo_interno := TIntegerField.Create(Self);
  ModalidadesDatasetexcluido := TBooleanField.Create(Self);
  ModalidadesDatasetinclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetalteracao := TDateTimeField.Create(Self);
  ModalidadesDatasetexclusao := TDateTimeField.Create(Self);
  ModalidadesDatasetapi_pixid := TIntegerField.Create(Self);
  ModalidadesDatasetpix_integrado := TBooleanField.Create(Self);
  ModalidadesDatasetstatus := TIntegerField.Create(Self);
  ModalidadesDatasetmodalidade_web := TBooleanField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  ModalidadesDataset.BeforeLoadDFMValues;
  ModalidadesDatasetnome.BeforeLoadDFMValues;
  ModalidadesDatasetpermite_prazo.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_avista.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_cheque_vinculado.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_prazo_fixo.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_pagamento_digital.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_pix.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_cartao.BeforeLoadDFMValues;
  ModalidadesDatasettipo_cartao.BeforeLoadDFMValues;
  ModalidadesDatasetprazo_dias.BeforeLoadDFMValues;
  ModalidadesDatasetdia_fixo.BeforeLoadDFMValues;
  ModalidadesDatasetcodigo_interno.BeforeLoadDFMValues;
  ModalidadesDatasetexcluido.BeforeLoadDFMValues;
  ModalidadesDatasetinclusao.BeforeLoadDFMValues;
  ModalidadesDatasetalteracao.BeforeLoadDFMValues;
  ModalidadesDatasetexclusao.BeforeLoadDFMValues;
  ModalidadesDatasetapi_pixid.BeforeLoadDFMValues;
  ModalidadesDatasetpix_integrado.BeforeLoadDFMValues;
  ModalidadesDatasetstatus.BeforeLoadDFMValues;
  ModalidadesDatasetmodalidade_web.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewModalidadesList';
    Width := 564;
    Height := 364;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 320;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 38;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellData', 'WebDBTableControl1GetCellData');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    SetEvent(WebDBTableControl1, Self, 'OnGetCellClass', 'WebDBTableControl1GetCellClass');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'A'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'C'#243'd. Retaguarda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nome';
      Title := 'nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status';
      Title := 'status';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'permite_prazo';
      Title := 'Permite Prazo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_avista';
      Title := #192' Vista';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_cheque_vinculado';
      Title := 'Cheque Vinculado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_prazo_fixo';
      Title := 'Prazo Fixo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_pagamento_digital';
      Title := 'Pag. Digital';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_pix';
      Title := 'Pix';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pix_integrado';
      Title := 'Pix Integrado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_web';
      Title := 'Web';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_cartao';
      Title := 'Cart'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'tipo_cartao';
      Title := 'Tipo Cart'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'prazo_dias';
      Title := 'Prazo Dias';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'dia_fixo';
      Title := 'Dia Fixo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'Exclu'#237'do';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'Inclus'#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'Altera'#231#227'o';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'Exclus'#227'o';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 11;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 11;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 309;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    ModalidadesDataset.SetParentComponent(Self);
    ModalidadesDataset.Name := 'ModalidadesDataset';
    ModalidadesDataset.EntitySetName := 'Modalidades';
    ModalidadesDataset.Connection := DMConnection.ApiConnection;
    ModalidadesDataset.Left := 72;
    ModalidadesDataset.Top := 88;
    ModalidadesDatasetnome.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetnome.Name := 'ModalidadesDatasetnome';
    ModalidadesDatasetnome.FieldName := 'nome';
    ModalidadesDatasetnome.Required := True;
    ModalidadesDatasetnome.Size := 255;
    ModalidadesDatasetpermite_prazo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetpermite_prazo.Name := 'ModalidadesDatasetpermite_prazo';
    ModalidadesDatasetpermite_prazo.FieldName := 'permite_prazo';
    ModalidadesDatasetpermite_prazo.Required := True;
    ModalidadesDatasetmodalidade_avista.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_avista.Name := 'ModalidadesDatasetmodalidade_avista';
    ModalidadesDatasetmodalidade_avista.FieldName := 'modalidade_avista';
    ModalidadesDatasetmodalidade_avista.Required := True;
    ModalidadesDatasetmodalidade_cheque_vinculado.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_cheque_vinculado.Name := 'ModalidadesDatasetmodalidade_cheque_vinculado';
    ModalidadesDatasetmodalidade_cheque_vinculado.FieldName := 'modalidade_cheque_vinculado';
    ModalidadesDatasetmodalidade_cheque_vinculado.Required := True;
    ModalidadesDatasetmodalidade_prazo_fixo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_prazo_fixo.Name := 'ModalidadesDatasetmodalidade_prazo_fixo';
    ModalidadesDatasetmodalidade_prazo_fixo.FieldName := 'modalidade_prazo_fixo';
    ModalidadesDatasetmodalidade_prazo_fixo.Required := True;
    ModalidadesDatasetmodalidade_pagamento_digital.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_pagamento_digital.Name := 'ModalidadesDatasetmodalidade_pagamento_digital';
    ModalidadesDatasetmodalidade_pagamento_digital.FieldName := 'modalidade_pagamento_digital';
    ModalidadesDatasetmodalidade_pagamento_digital.Required := True;
    ModalidadesDatasetmodalidade_pix.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_pix.Name := 'ModalidadesDatasetmodalidade_pix';
    ModalidadesDatasetmodalidade_pix.FieldName := 'modalidade_pix';
    ModalidadesDatasetmodalidade_pix.Required := True;
    ModalidadesDatasetmodalidade_cartao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_cartao.Name := 'ModalidadesDatasetmodalidade_cartao';
    ModalidadesDatasetmodalidade_cartao.FieldName := 'modalidade_cartao';
    ModalidadesDatasetmodalidade_cartao.Required := True;
    ModalidadesDatasettipo_cartao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasettipo_cartao.Name := 'ModalidadesDatasettipo_cartao';
    ModalidadesDatasettipo_cartao.FieldName := 'tipo_cartao';
    ModalidadesDatasetprazo_dias.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetprazo_dias.Name := 'ModalidadesDatasetprazo_dias';
    ModalidadesDatasetprazo_dias.FieldName := 'prazo_dias';
    ModalidadesDatasetdia_fixo.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetdia_fixo.Name := 'ModalidadesDatasetdia_fixo';
    ModalidadesDatasetdia_fixo.FieldName := 'dia_fixo';
    ModalidadesDatasetcodigo_interno.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetcodigo_interno.Name := 'ModalidadesDatasetcodigo_interno';
    ModalidadesDatasetcodigo_interno.FieldName := 'codigo_interno';
    ModalidadesDatasetcodigo_interno.Required := True;
    ModalidadesDatasetexcluido.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetexcluido.Name := 'ModalidadesDatasetexcluido';
    ModalidadesDatasetexcluido.FieldName := 'excluido';
    ModalidadesDatasetinclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetinclusao.Name := 'ModalidadesDatasetinclusao';
    ModalidadesDatasetinclusao.FieldName := 'inclusao';
    ModalidadesDatasetinclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetalteracao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetalteracao.Name := 'ModalidadesDatasetalteracao';
    ModalidadesDatasetalteracao.FieldName := 'alteracao';
    ModalidadesDatasetalteracao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetexclusao.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetexclusao.Name := 'ModalidadesDatasetexclusao';
    ModalidadesDatasetexclusao.FieldName := 'exclusao';
    ModalidadesDatasetexclusao.DisplayFormat := 'dd/mm/yy hh:nn:ss';
    ModalidadesDatasetapi_pixid.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetapi_pixid.Name := 'ModalidadesDatasetapi_pixid';
    ModalidadesDatasetapi_pixid.FieldName := 'api_pix.id';
    ModalidadesDatasetpix_integrado.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetpix_integrado.Name := 'ModalidadesDatasetpix_integrado';
    ModalidadesDatasetpix_integrado.FieldName := 'pix_integrado';
    ModalidadesDatasetpix_integrado.Required := True;
    ModalidadesDatasetstatus.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetstatus.Name := 'ModalidadesDatasetstatus';
    ModalidadesDatasetstatus.FieldName := 'status';
    ModalidadesDatasetmodalidade_web.SetParentComponent(ModalidadesDataset);
    ModalidadesDatasetmodalidade_web.Name := 'ModalidadesDatasetmodalidade_web';
    ModalidadesDatasetmodalidade_web.FieldName := 'modalidade_web';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := ModalidadesDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 144;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 455;
    tmrConsulta.Top := 192;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    ModalidadesDataset.AfterLoadDFMValues;
    ModalidadesDatasetnome.AfterLoadDFMValues;
    ModalidadesDatasetpermite_prazo.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_avista.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_cheque_vinculado.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_prazo_fixo.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_pagamento_digital.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_pix.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_cartao.AfterLoadDFMValues;
    ModalidadesDatasettipo_cartao.AfterLoadDFMValues;
    ModalidadesDatasetprazo_dias.AfterLoadDFMValues;
    ModalidadesDatasetdia_fixo.AfterLoadDFMValues;
    ModalidadesDatasetcodigo_interno.AfterLoadDFMValues;
    ModalidadesDatasetexcluido.AfterLoadDFMValues;
    ModalidadesDatasetinclusao.AfterLoadDFMValues;
    ModalidadesDatasetalteracao.AfterLoadDFMValues;
    ModalidadesDatasetexclusao.AfterLoadDFMValues;
    ModalidadesDatasetapi_pixid.AfterLoadDFMValues;
    ModalidadesDatasetpix_integrado.AfterLoadDFMValues;
    ModalidadesDatasetstatus.AfterLoadDFMValues;
    ModalidadesDatasetmodalidade_web.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
